import * as types from '../../action-types';
import { getPayments as initialState } from "../../initialState";

const getPayments = (state=initialState, action) => {
  switch (action.type) {
    case types.GET_PAYMENTS_START:
      return {
        ...state,
        isLoading: true
      };
    case types.GET_PAYMENTS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        isSuccessful: true,
        data: action.payload
      };
    case types.GET_PAYMENTS_FAIL:
      return {
        ...state,
        isLoading: false,
        error: action.payload
      };
    case types.GET_PAYMENTS_CLEANUP:
      return {
        ...state,
        isLoading: false,
        isSuccessful: false,
        error: null
      };
    default:
      return state;
  }
}

export default getPayments;
